module.exports = __webpack_public_path__ + "img/onMobile.3006eb18.svg";